import React from "react";

import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

const DropdownBox = (props) => {
  const {
    label,
    options,
    getOptionLabel,
    placeholder,
    onChange,
    defaultValue,
  } = props;

  return (
    <>
      <Typography>{label}</Typography>
      <FormControl fullWidth>
        <Autocomplete
          options={options}
          getOptionLabel={getOptionLabel}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={placeholder}
            />
          )}
          defaultValue={defaultValue || null}
          onChange={onChange}
        />
      </FormControl>
    </>
  );
};

export default DropdownBox;
